import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {CirfService} from "../cirf.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {FormControl, FormGroup} from "@angular/forms";
import {Utils} from "../../common/utils";
import {CirfMortgage, MortgageTypeValue} from "../cirf-mortgage";
import {Cirf} from "../cirf";
import {CirfDocument} from "../cirf-document";
import {FileUploadService} from "../../common/file-upload/file-upload.service";
import {ConfirmDialogService} from "../../common/confirm-dialog/confirm-dialog.service";
import {UploadedFileDescription} from "../../shared/constants";
import {ConnectDialog} from "../../common/confirm-dialog/connect-dialog";
import {CirfConfigService} from "../config/cirf-config-service";
import {CIRF_CONFIG_KEYS} from "../config/cirf-config-keys";
import {CirfUdf} from "../cirf-udf";


@Component({
    selector: 'dp-mortgage-form',
    templateUrl: './mortgage-form.component.html'
})
export class MortgageFormComponent implements OnInit, OnDestroy {

    @Input() mortgageId: string;

    matterTypeText: string;
    mortgage: CirfMortgage;
    mortgageIndex: number;
    cirfMortgageDocuments: CirfDocument[] = [];
    scheduler : any;
    mortgageStatementDescription = UploadedFileDescription.mortgageStatement;

    bankNameFieldKey: string;
    referenceNumberFieldKey: string;
    brokerNameFieldKey: string;
    brokerEmailFieldKey: string;
    brokerPhoneFieldKey: string;
    mortgageNotesFieldKey: string;
    showMortgageNotesStep: boolean;
    showMortgageDetailsStep: boolean;

    constructor(public router : Router  ,
                private route: ActivatedRoute ,
                public fileUploadService: FileUploadService,
                public confirmDialogService : ConfirmDialogService,
                public cirfService : CirfService,
                private cirfConfigService: CirfConfigService) { }

    ngOnInit() {
        setTimeout(()=>{
            this.matterTypeText = this.cirfService.matterTypeText;
            this.setUpMortgage(Number(this.mortgageId));
            this.startPolling();
        }, 100);

    }

    setUpMortgage(mortgageId : number) : void {
        if(!!mortgageId){
            this.mortgage  =  this.cirfService.mortgages.find(item => item.id == mortgageId.toString());
            if(!this.mortgage){
                this.mortgage = new CirfMortgage();
                this.mortgage.id = Utils.uuid();
                this.mortgage.mortgageType = MortgageTypeValue.New;
                this.cirfService.saveMortgage(this.mortgage);
                this.cirfService.setUpFormControl(this.cirf);
            }
        }
        this.bankNameFieldKey = this.mortgage.isNewMortgage() ? 'newMortgage.bankName' : 'existingMortgage.bankName';
        this.referenceNumberFieldKey = this.mortgage.isNewMortgage() ? 'newMortgage.referenceNumber' : 'existingMortgage.referenceNumber';
        this.brokerNameFieldKey = this.mortgage.isNewMortgage() ? 'newMortgage.broker.name' : 'existingMortgage.broker.name';
        this.brokerEmailFieldKey = this.mortgage.isNewMortgage() ? 'newMortgage.broker.email' : 'existingMortgage.broker.email';
        this.brokerPhoneFieldKey = this.mortgage.isNewMortgage() ? 'newMortgageBroker.phone1.telephoneNumber' : 'existingMortgageBroker.phone1.telephoneNumber';
        this.mortgageNotesFieldKey = this.mortgage.isNewMortgage() ? 'newMortgage.mortgageNotes' : 'existingMortgage.mortgageNotes';
        this.showMortgageNotesStep = !this.cirfConfigService.isFieldHidden(this.mortgageNotesFieldKey);
        this.showMortgageDetailsStep = this.doesMortgageDetailsHasAnyFieldsVisible() || (!this.doesMortgageDetailsHasAnyFieldsVisible() && !this.showMortgageNotesStep && this.mortgage.isNewMortgage()) || (this.mortgage.isExistingMortgage() && this.doesMortgageDetailsHasAnyFieldsVisible());

        this.mortgageId = this.mortgage.id;
        if(mortgageId > 0){
            Utils.invokeFieldLevelValidation(this.formGroup);
        }
        this.getMortgageIndex();
        this.setupMortgageNotes();
        this.onChanges();
    }

    doesMortgageDetailsHasAnyFieldsVisible() : boolean {
        let udfKey = this.mortgage && this.mortgage.isNewMortgage() ? CIRF_CONFIG_KEYS.newMortgageUdf : CIRF_CONFIG_KEYS.existingMortgageUdf;
        let udfCount = this.mortgageUdfs && this.mortgageUdfs.length;
        return !(this.cirfConfigService.areFieldsHidden(`${this.bankNameFieldKey};${this.referenceNumberFieldKey};${this.brokerNameFieldKey};${this.brokerEmailFieldKey};${this.brokerPhoneFieldKey}`)
                && this.cirfConfigService.areAllUDFsHidden(udfKey, udfCount));
    }

    getMortgageIndex() : void {
        let mortgages = this.mortgage.isNewMortgage() ? this.cirf.newMortgages : this.cirf.existingMortgages;
        this.mortgageIndex = Number(mortgages.findIndex(mtg=>mtg.id == this.mortgageId)) + 1;
    }

    get cirf() : Cirf {
        return this.cirfService.cirf
    }

    get formGroup() : FormGroup {
        return this.cirfService.cirfFormGroup.get('cirfMatterData')['controls'].mortgages.controls.find(item => !!this.mortgageId && item.value.id == this.mortgageId);
    }
    onChanges(): void {
        this.cirfService.saveChangesOnCirfFormChanges();
    }


    async saveMortgageForm(route? : string[]) {
        // this.saveMortgageNotes();
        if(!!this.cirfService.cirf) {
            let cirf = await this.cirfService.updateCirf('INPROGRESS');
            if(cirf){
                if (route) {
                    this.router.navigate(route, {relativeTo: this.route});
                }
            }
        }
        else if(route){
            this.router.navigate(route, {relativeTo: this.route});
        }
    }

    backToClientListPage() : void {
        this.saveMortgageForm(['../../../cirfs']);
    }

    public startPolling() : void {
        this.getCirfDocuments();
        clearInterval(this.scheduler);
        this.scheduler = setInterval(() => {
            this.getCirfDocuments();
        }, 5000);
    }

    stopPolling() : void {
        window.clearInterval(this.scheduler);
    }

    getCirfDocuments() : void {
        this.fileUploadService.getCirfDocuments(this.cirf.cirfGuid).subscribe(
            (documents)=>{
                this.cirfMortgageDocuments = documents.filter(doc=>doc.sourceId == this.mortgageId);
                if(this.cirfMortgageDocuments && !this.cirfMortgageDocuments.length){
                    this.stopPolling();
                } else {
                    if(this.cirfMortgageDocuments.every( doc => doc.isVirusClean())){
                        this.stopPolling();
                    }
                }
            })
    }

    documentUploaded(event) {
        this.startPolling();
    }

    deleteDocument(document: CirfDocument) {
        let connectDialog = new ConnectDialog();
        connectDialog.message = 'Are you sure you want to delete this document?'
        connectDialog.dialogType = 'WARNING';
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if (res) {
                    this.fileUploadService.deleteCirfDocument(this.cirf.cirfGuid, String(document.id))
                        .subscribe((res)=>{
                            this.startPolling();
                        });
                }
            }
        )

    }

    ngOnDestroy() : void {
        // this.saveMortgageNotes();
        this.cirfService.updateCirf('INPROGRESS');
        this.stopPolling();
    }

    setupMortgageNotes() : void {
        if(!this.formGroup['mortgageNotes']){
            this.formGroup.addControl('mortgageNotes', new FormControl());
        }
        let mortgageNotes = this.mortgage.isNewMortgage() ? this.cirf?.cirfMatterData?.mortgageNotes : this.cirf?.cirfMatterData?.existingMortgageNotes;
        this.formGroup.controls.mortgageNotes.setValue(mortgageNotes);
    }

    // saveMortgageNotes() : void {
    //     if(this.mortgage.isNewMortgage()){
    //         this.cirfService.cirfFormGroup.get('cirfMatterData')['controls'].mortgageNotes.setValue(this.formGroup?.controls?.mortgageNotes?.value);
    //     } else {
    //         this.cirfService.cirfFormGroup.get('cirfMatterData')['controls'].existingMortgageNotes.setValue(this.formGroup?.controls?.mortgageNotes?.value);
    //     }
    //
    // }

    get mortgageStatementDocument() : CirfDocument {
        if(this.cirfMortgageDocuments && this.cirfMortgageDocuments.length){
            return this.cirfMortgageDocuments.find(doc => doc.sourceId == this.mortgageId && doc.description == this.mortgageStatementDescription);
        } else {
            return null;
        }
    }

    get mortgageUdfFieldKey() : string {
        return this.mortgage.isExistingMortgage() ? CIRF_CONFIG_KEYS.existingMortgageUdf : CIRF_CONFIG_KEYS.newMortgageUdf;
    }

    get mortgageUdfs() : CirfUdf[] {
        return this.mortgage.mortgageUdfs;
    }

}
